import React from 'react';
import {
  ILogicalOperatorFieldsFragment,
  IPredicateFieldsFragment,
} from '../../../../../utils/apollo/graphqlSchema';
import BasicFilterPredicate from './BasicFilterPredicate';
import * as BasicFilterViewUI from '../BasicFilterViewUI';

interface IProps {
  predicate: IPredicateFieldsFragment;
  predicateIndex: number;
  logicOp: ILogicalOperatorFieldsFragment;
  keyPrefix: string;
}

const BasicFilterConditionPredicate = ({
  predicate,
  predicateIndex,
  logicOp,
  keyPrefix,
}: IProps) => {
  const key = keyPrefix + `-predicate-${predicateIndex}`;

  return (
    <>
      <BasicFilterPredicate predicate={predicate} keyPrefix={key} />
      {logicOp && (
        <BasicFilterViewUI.LogicOp>{logicOp.key}</BasicFilterViewUI.LogicOp>
      )}
    </>
  );
};

export default BasicFilterConditionPredicate;
